theme.JelenewImageEffects = new (function () {
  this.onSectionLoad = function (container) {
    jelenewSectionAppendTemplate(".jelenew-image-effects-template", container);
    var $container=$(container);
    //pc效果
    $container.on("mouseover", ".jelenew-image-effects-item", function () {
      
      var $this = $(this);
      if (window.innerWidth < 767) return;
      if($this.hasClass("active")) return;
      $(".jelenew-image-effects-item",container).removeClass("active")
      $this.addClass("active")
    })
    if (window.innerWidth < 767){
      //监听页面滚动，div出现在屏幕中就加载
      $(window).scroll(function() {
         $itemObj=$(".jelenew-image-effects-item",container);
         
         $itemObj.each(function (index, itemElement) {
              
              // div距离顶部的距离
              let divBottom = $(itemElement).offset().top;
              // div的高度
              let divHeight=$(itemElement).height()*2.5+50;
              let windowBottom = $(window).scrollTop() + $(window).height();
              // div出现在屏幕中的高度
              let scrollheight=windowBottom-divBottom;
              let imgheight=windowBottom-divBottom;
              if(scrollheight <= 100){
                $(itemElement).find(".jelenew-image-effects-item-btn").css("transform","translate(-50%,100px)")
              }
              if(scrollheight < divHeight && scrollheight > 100){
                let divTop=(scrollheight/2-100)/1.5+100;
                if(divTop <= 440 && divTop >=100){
                  $(itemElement).find(".jelenew-image-effects-item-btn").css("transform","translate(-50%,"+divTop+"px)")
                }
                let imgTop=((imgheight-100)/8)-50;
                if(imgTop <= 0){
                  $(itemElement).find(".jelenew-image-container img").css("transform","translate(0,"+imgTop+"px)")
                }
              }
              if(scrollheight >= divHeight){
                // $(itemElement).find(".jelenew-image-effects-item-btn").css("top","400px")
                // $(itemElement).find(".jelenew-image-container img").css("transform","translate(0,0px)")
                $(itemElement).find(".jelenew-image-effects-item-btn").css("transform","translate(-50%,440px)")
              }
         })
      })
    }
    
  };
})();
theme.Sections.register("jelenew-image-effects", theme.JelenewImageEffects, { deferredLoad: true });